import { Switch, Tooltip, Typography } from 'antd'
import React, { Dispatch, FC, ReactNode, SetStateAction } from 'react'
import styled from 'styled-components'

const { Text } = Typography

export interface FfsParameterSwitchProps {
  setValue: Dispatch<SetStateAction<boolean>>
  value: boolean
  label: ReactNode
  labelWidth: string
  checkedContent?: ReactNode
  uncheckedContent?: ReactNode
  labelTooltip?: string
}

const Container = styled.div`
  display: flex;
  position: relative;
  flex-direction: row;
  justify-content: left;
  width: 100%;
  aligh-items: center;
  gap: 1rem;
  padding-bottom: 0.3rem;
`

const RawFfsParameterSwitch: FC<FfsParameterSwitchProps> = ({
  value,
  setValue,
  label,
  labelWidth,
  checkedContent,
  uncheckedContent,
  labelTooltip,
}) => {
  return (
    <Container>
      <Tooltip title={labelTooltip}>
        <Text style={{ width: labelWidth ?? '30%' }}>{label}</Text>
      </Tooltip>
      <Switch
        checked={value}
        onChange={setValue}
        checkedChildren={checkedContent}
        unCheckedChildren={uncheckedContent}
      />
    </Container>
  )
}

export const FfsParameterSwitch = React.memo(RawFfsParameterSwitch)
